import OverlayManager from "../OverlayManager.js";

class Overlay {
    /**
     * @author Corentin (ccharton) Charton
     * @description Overlay class to manage overlay interactions
     */
    constructor() {
    }

    /**
     * @author Corentin (ccharton) Charton
     * @description Close the overlay and restore previous input mode
     */
    closeOverlay() {
        OverlayManager.toggle()
        if (OverlayManager.game && OverlayManager.game?.camera?.inputManager) {
            OverlayManager.game?.camera?.inputManager.changeInputMode(OverlayManager.game?.camera?.inputManager.previousInputControlMode)
            if (OverlayManager.game?.camera?.inputManager.activeInputController === 'virtualGamepadController') {
                OverlayManager.game?.camera?.inputManager?.virtualGamepadController.show()
            } else if (OverlayManager.game?.camera?.inputManager.activeInputController === 'keyboardMouse') {
                OverlayManager.game?.camera?.inputManager.keyboardMouseController.canvas.requestPointerLock()
            }
        }
    }
}

export default new Overlay()